<kl-grid
  [columns]="[
    {
      header: 'type',
      binding: 'type',
      width: 210,
      translate: true,
      visible: true
    },
    {
      header: 'status',
      binding: 'status',
      width: 210,
      translate: true,
      visible: true
    },
    { header: 'code', binding: 'code', width: 210, visible: true },
    {
      header: 'description',
      binding: 'description',
      width: 280,
      visible: true
    },
    {
      header: 'product_group',
      binding: 'product_group',
      width: 210,
      translate: true,
      visible: true
    },
    {
      header: 'package_type',
      binding: 'package_type',
      width: 210,
      translate: true,
      visible: true
    },
    {
      header: 'short_description',
      binding: 'short_description',
      width: 280,
      visible: true
    },
    {
      header: 'special_code',
      binding: 'special_code',
      width: 210,
      visible: true
    }
  ]"
  [filterable]="true"
  [deferResizing]="true"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'material',
    name: 'materials' | translate,
    filterChild: 'flat',
    form: 'MATERIAL',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'MATERIAL_MANAGEMENT'"
  [moduleName]="'MATERIAL_LIST'"
  [gridName]="'grdMaterialList'"
  [customFilter]="true"
  [dblSelect]="dblSelect"
  [filterSelectItems]="filterSelectItems"
  [filterObject]="filterObject"
  [customFilterOutlet]="'MATERIAL_DETAIL_FILTER'"
>
</kl-grid>
